{
  "el": {
    "datatable": {
      "actions": {
        "bulk_action": "Μαζική ενέργεια",
        "bulk_edit": "Μαζική επεξεργασία",
        "clear": "Εκκαθάριση",
        "clear_filters": "Εκκαθάριση φίλτρων",
        "collapse_all": "Σύμπτυξη όλων",
        "deselect_all": "Αποεπιλογή όλων",
        "expand_all": "Ανάπτυξη όλων",
        "select_all": "Επιλογή όλων"
      },
      "import": {
        "error_row": "Γραμμή {row}",
        "errors_description": "Η εισαγωγή ακυρώθηκε επειδή {count} γραμμές περιείχαν σφάλματα. Δεν έγινε εισαγωγή καμίας εγγραφής.",
        "errors_title": "Η εισαγωγή απέτυχε",
        "success": "Το αρχείο εισήχθη με επιτυχία",
        "title": "Εισαγωγή"
      },
      "labels": {
        "columns_selected": "{count} επιλεγμένες στήλες",
        "freeze_columns": "Πάγωμα στηλών",
        "freeze_rows": "Πάγωμα γραμμών",
        "gridlines": "Γραμμές πλέγματος",
        "group_by": "Ομαδοποίηση κατά",
        "size": "Μέγεθος",
        "sticky_headers": "Σταθερές κεφαλίδες",
        "striped_rows": "Εναλλασσόμενες γραμμές",
        "toggle_columns": "Εναλλαγή στηλών",
        "translation_mode_header": "Κεφαλίδα",
        "translation_mode_stacked": "Στοιβαγμένο",
        "translation_mode_toolbar": "Καθολικό",
        "translation_style": "Στυλ μετάφρασης"
      }
    }
  }
}
